import { ProductDetailsBenefitCategorySelectorEnum } from '../../../types/cmsEnums';
import { CmsProduct } from '../../../types/cmsProduct';
import { groupProductAttributes } from '../../../utils/helpers';

/**
 * Every benefit category the product carries attributes for — the modal-mode
 * fallback when no editor-configured selector is available, so Benefits shows
 * the full picture instead of hiding (CMS-1924).
 */
export const getProductBenefitCategories = (
  product?: CmsProduct,
): ProductDetailsBenefitCategorySelectorEnum[] => {
  const { benefitsAirmiles, benefitsRewardsPoints, benefitsCashback } =
    groupProductAttributes(product);

  const categories: ProductDetailsBenefitCategorySelectorEnum[] = [];
  if (benefitsCashback?.length) categories.push('CASHBACK');
  if (benefitsAirmiles?.length) categories.push('AIRMILES');
  if (benefitsRewardsPoints?.length) categories.push('REWARDS_POINTS');
  return categories;
};
